import React from 'react';

const Footer = () => '';

export default React.memo(Footer);
